<template>
	<div class="whydifferent">
		<Loading msg="loading" v-if="!isload" />
		<div class="why_different_inner" v-else>
        	<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
            <h1 class="inner_title">为什么基因结论<br>跟我的现状不一样?</h1>
            <img src="../assets/images/result_and_state_pic.jpg" class="inner_title_pic" alt="">
            <p class="inner_sub_text">基因是每个人生命的蓝图，我们身体、皮肤的性状，包括天生肤色、头发卷曲甚至一些疾病风险等都是先天基因所决定的。但目前的检测结果有的可能和现状有一定区别，其中的原因包括：</p>
            <div class="second_title">环境条件不一样</div>
            <p class="second_title_text">在每个人的成长过程中，饮食习惯和受到的环境影响不一样，会导致我们的现状不一样。比如在不同饮食结构的情况下，相同基因的双胞胎可能身高就会出现明显的差别。皮肤也是如此，比如在青少年时期是痤疮高发时候，在不同温度、湿度和环境条件下，即使基因一样的人痤疮发生的可能也不一样。另一个重要的环境因素是紫外线强度，普遍来说在紫外线强的高原地区（如云南、西藏等地）生活的人，肤色就比其它地区的要深。 </p>
            <div class="second_title">生活方式不一样</div>
            <p class="second_title_text">不同的生活方式会对身体的新陈代谢有很大的影响，即使是基因类似的人在不同的生活、作息情况下身体状态也会差异很大。比如有“肥胖”基因的人，如果能够保持健康的饮食和长期运动，也能很好地控制体重。在皮肤问题上也是类似，比如在皮肤屏障基因较弱、炎症反应较强的敏感肌人群中，如果有不一样的护肤方式和运动饮食管理，肌肤敏感发生的可能性也不一样。  </p>
            <div class="second_title">科学技术的局限</div>
            <p class="second_title_text">目前生物科技已经有了很大的发展，我们对于基因的理解和知识也有了一定的积累。但关于皮肤基因完整的功能和调控我们还没有100%了解，后续随着科学的发展和研究的深入，我们将不断更新位点和算法，对皮肤基因的检测准确度将越来越高。  </p>
		
		</div>
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";

export default {
  name: "WhyDifferent",
  data() {
    return {
	  isload: true
    };
  },

  created() {
    console.log("whydifferent created", this);
 
  },
  methods: {

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
.back_btn{
  position:fixed;
  top:30/50rem;
  left:0;
  z-index:99999;
  width:118/50rem;
  height:54/50rem;
}
.why_different_inner{
    padding:107/50rem 30/50rem;
    .inner_title{
    font-size:44/50rem;
    line-height:48/50rem;
    font-weight:bold;
    color:@font-c-3;
    padding-bottom:57/50rem;
    }
    .inner_title_pic{
        width:100%;
        .shadow;
        .border-radius(14/50rem);
    }
    .inner_sub_text{
        padding:30/50rem 0 72/50rem;
        font-size:24/50rem;
        line-height:30/50rem;
        color:@font-c-9;
    }
    .second_title{
        font-size:30/50rem;
        line-height:1em;
        color:@font-c-3;
        font-weight:bold;
    }
    .second_title_text{
        padding:20/50rem 0 70/50rem;
        font-size:24/50rem;
        line-height:30/50rem;
        color:@font-c-6;
    }
}


</style>
